import { CampaignBriefProductsState } from "../types/campaign-brief-products.interface";
import { createCampaignBriefProductsState } from "../types/campaign-brief-products.functions";

import {
  CampaignBriefProductsActions,
  CampaignBriefProductsActionType,
} from "./campaign-brief-products.actions";

export function CampaignBriefProductsReducer(
  state = createCampaignBriefProductsState(),
  action: CampaignBriefProductsActionType
): CampaignBriefProductsState {
  switch (action.type) {
    case CampaignBriefProductsActions.FetchProducts:
      return {
        ...state,
        errors: null,
        loading: true,
        products: [],
      };

    case CampaignBriefProductsActions.AddProduct:
    case CampaignBriefProductsActions.UpdateProducts:
      return {
        ...state,
        errors: null,
        loading: true,
      };

    case CampaignBriefProductsActions.AddProductFailure:
    case CampaignBriefProductsActions.FetchProductsFailure:
    case CampaignBriefProductsActions.UpdateProductsFailure:
      return {
        ...state,
        errors: action.payload,
        loading: false,
      };

    case CampaignBriefProductsActions.AddProductSuccess:
      return {
        ...state,
        loading: false,
        products: [action.payload].concat(state.products),
      };

    case CampaignBriefProductsActions.FetchProductsSuccess:
    case CampaignBriefProductsActions.UpdateProductsSuccess:
      return {
        ...state,
        loading: false,
        products: action.payload,
      };

    case CampaignBriefProductsActions.Reset:
      return createCampaignBriefProductsState();

    default:
      return state;
  }
}
